import { Component, Input } from '@angular/core';

@Component({
  selector: 'rt-icon-filter-lines',
  standalone: true,
  templateUrl: './rt-icon-filter-lines.component.html',
  styleUrls: ['./rt-icon-filter-lines.component.scss']
})
export class RtIconFilterLinesComponent {
  private readonly defaultConfig = {
    width: 16,
    height: 11
  };

  @Input() width: number | string = this.defaultConfig.width;
  @Input() height: number | string = this.defaultConfig.height;
}
